module.exports = __webpack_public_path__ + "static/shadows-layout-dont-b1bb9d9f38912118dde884b08160d9b6.png";